import React, { useState,useEffect } from "react";
import "./LpImaging.css";
import ImagingLpForm from "./ImagingLpForm";
import { MdDone } from "react-icons/md";
import { Ourpackages } from "../Imaging";
import { WhyChooseUs } from "../../../Pages/packageDetailsPage/Newlp";
import FAQstructure from "../../../Pages/homePage/FAQstructure";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Calltoaction } from "./HomepageImaging";
import checked from "./assets/checked.svg";
import Group from "./assets/Group.svg";
// import { OurServiceImaging } from "../Imaging";
import card1 from "../../../../src/Assets/newAsset/imaging/mri.svg";
import pet from "../../../../src/Assets/newAsset/imaging/pet.svg";
import ct from "../../../../src/Assets/newAsset/imaging/ct.svg";
import ultrasound from "../../../../src/Assets/newAsset/imaging/ultrasound.svg";
import mamory from "../../../../src/Assets/newAsset/imaging/mammography.svg";
import echo from "../../../../src/Assets/newAsset/imaging/Soundassistant.svg";
import tmt from "../../../../src/Assets/newAsset/imaging/ecg.svg";
import xray from "../../../../src/Assets/newAsset/imaging/outline.svg";
import mriM from "../../../../src/Assets/newAsset/imaging/mriM.svg";
import ctM from "../../../../src/Assets/newAsset/imaging/ctM.svg";
import peetM from "../../../../src/Assets/newAsset/imaging/peetM.svg";
import ultrasoundM from "../../../../src/Assets/newAsset/imaging/ultrasoundM.svg";
import mammographyM from "../../../../src/Assets/newAsset/imaging/mammographyM.svg";

//imagine faq
const ImagingFaq = [
  {
    id: 1,
    title: "What is an MRI scan? ",
    desc:
      "MRI or magnetic resonance imaging is non-invasive test doctors recommend for diagnosing medical conditions. It involves using a strong magnetic field, radiofrequency pulses, and a computer for forming detailed pictures of internal body structures. With this imaging test, it becomes easy for the doctor to diagnose and treat any clinical condition. The grouping of gradient coils of the magnetic resonance imaging or MRI device forms substantial vibration and noise. Energetic relations of these phenomena are examined relying on MRI scan parameters like echo time (TE), slice orientation sequence type, repetition time (TR), bodyweight. ",
  },
  {
    id: 2,
    title: "Is MRI risky? ",
    desc:
      "MRI uses powerful magnets. Hence, the presence of metal in a patient's body can be a safety hazard if attracted to the magnet. Patients with certain medical conditions like several prosthetic devices, pacemaker implants, cochlear implants, intracranial aneurysm clips, etc. are recommended not to undergo an MRI procedure. ",
  },
  {
    id: 3,
    title: "What are the risks involved with an MRI scan?",
    desc:
      "An MRI scan is known as the secured image diagnostic test currently, thus, there are no severe risks associated with it. ",
  },
  {
    id: 4,
    title: "Difference between CT scans and MRIs? ",
    desc:
      "The use of MRI and CT scans is mostly for similar reasons; the only difference is their functionalities. A CT scan involves using several X-rays for capturing the images of the physiology inner structure, whereas an MRI scan is for the robust magnetic fields and radio waves for achieving the same. Nonetheless, MRI doesn’t involve forming the radiation and is safe than CT scan, and also has the efficiency of delivering more descriptive images.",
  },
  {
    id: 5,
    title: "Should you eat or drink the night before the MRI scan?",
    desc:
      "No, doctors don’t recommend eating or drinking anything before the MRI scan.",
  },
];
//imagine testimonials
const ImagingTestimonials = [
  {
    id: 1,
    title: "Speedy Report",
    author_name: "Harvinder Kaur ",
    address: false,
    description:
      "I wanted to get the MRI scan done and was looking for reliable and trustworthy imaging services. One of my friends asked me to get in touch with Redcliffe Labs. They have the best imaging services and highly recommend them. I had a very nice experience as they took care of everything for me. You should certainly try.",
  },
  {
    id: 2,
    title: "Excellent Service",
    author_name: "Shivam Kumar ",
    address: false,
    description:
      "Redcliffe Labs is one of the best imaging services you can ever find. I was asked to get the MRI scan done by a doctor and I chose them. Trust me, they have got the best team and are highly professional. They never compromise on quality and reports are also delivered within the given time. I would highly recommend.",
  },
  {
    id: 3,
    title: "Prompt Service",
    author_name: "Priya Singla ",
    address: false,
    description:
      "My mother had health issues and after getting in touch with the doctor we got to know that an MRI was needed. So, we got in touch with Redcliffe Labs as one of the relatives had recommended them and we really liked their services. I can definitely recommend. ",
  },
];

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const responsiveOurService = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 5,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 4,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 2,
  },
};



function LpImageing() {
  const [home, setHome] = useState(false);
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    // const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

    // if (window?.navigator?.userAgentData) {
    //   setIsMobile(window?.navigator?.userAgentData?.mobile)
    // } else if (isSafari) {
    //   setIsMobile(false)
    // } else {
    //   setIsMobile(true)
    // }

    setIsMobile(false)
  }, [])
  

  return (
    <>
      <div className="lpImaging">
        <div className="lpImaginContainer">
          <div className="lpImgingLeftside">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/9f72807e-aec8-497c-8327-987bdfcd0b58.png"
              className="imglpLogo"
            />
            <div className="mobileBackground">
              <div className="imagingText">
                <span className="brightText">ONE-STOP SOLUTION</span>
                <span className="pinkText"> for all your imaging needs!</span>
                <span className="subText">
                  Imaging Diagnostic Services Now Under One Roof
                </span>
              </div>
              <div className="ImagingpriceTag">
                Starts From <span>₹600/-</span>
              </div>
            </div>

            <div className="mri-card">
              <div className="lpImagingCard">
                <img src={checked} alt="mri" />
                <span>PET Scan</span>
              </div>
              <div className="lpImagingCard">
                <img src={checked} alt="mri" />
                <span>MRI Scan</span>
              </div>
              <div className="lpImagingCard">
                <img src={checked} alt="mri" />
                <span>CT Scan</span>
              </div>
              <div className="lpImagingCard">
                <img src={checked} />
                <span>Ultrasound</span>
              </div>
              <div className="lpImagingCard">
                <img src={checked} alt="mri" />
                <span>Mammography</span>
              </div>
              <div className="lpImagingCard">
                <img src={checked} alt="mri" />
                <span>ECHO</span>
              </div>
              <div className="lpImagingCard">
                <img src={checked} alt="mri" />
                <span>X-Ray</span>
              </div>
              <div className="lpImagingCard">
                <img src={checked} alt="mri" />
                <span>TMT</span>
              </div>
            </div>
            {/* <ul className="mobilePackagelist">
              <li>
                <MdDone /> MRI Scan
              </li>
              <li>
                <MdDone /> Ultrasound
              </li>
              <li>
                <MdDone /> PET Scan
              </li>
              <li>
                <MdDone /> CT Scan
              </li>
              <li>
                <MdDone /> Mammography
              </li>
            </ul> */}
          </div>
          <div className="lpImgingRightside">
            <div className="imagingSubmit">
              {" "}
              <ImagingLpForm
                isImagine={true}
                isLp={true}
                push={true}
                upload={true}
                formId={'ImagingLpTop'}
                isMobile={isMobile}
              />
            </div>
          </div>
        </div>
      </div>
      {/* <div className="DesktopPackage">
        <Ourpackages />
      </div> */}

      <div className="imagine_Ourpackage_Lp">
        <div className="parentDivImagine">
          <div className="imagine_heading">
            <h2 className="textPink">Our Services</h2>
            <span>All Imaging Services Under One Roof</span>
          </div>
          <div className="mobileImagineDiv">
            <div className="imagineCardRow">
              <Carousel
                swipeable={true}
                draggable={false}
                showDots={false}
                responsive={responsiveOurService}
                ssr={true}
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={2500}
                transitionDuration={200}
              >
                <div className="cardImagine">
                  <img src={card1} />
                  <span className="textBlue">MRI Scan</span>
                </div>
                <div className="cardImagine">
                  <img src={pet} />
                  <span className="textBlue">PET Scan</span>
                </div>

                <div className="cardImagine">
                  <img src={ct} />
                  <span className="textBlue">CT Scan</span>
                </div>

                <div className="cardImagine">
                  <img src={ultrasound} />
                  <span className="textBlue">Ultrasound</span>
                </div>

                <div className="cardImagine">
                  <img src={mamory} />
                  <span className="textBlue">Mammography</span>
                </div>

                <div className="cardImagine">
                  <img src={echo} />
                  <span className="textBlue">ECHO</span>
                </div>
                <div className="cardImagine">
                  <img src={xray} />
                  <span className="textBlue">X-Ray</span>
                </div>
                <div className="cardImagine">
                  <img src={tmt} />
                  <span className="textBlue">TMT</span>
                </div>
              </Carousel>
            </div>
          </div>
        </div>
      </div>

      <div className="MobilePackageCard">
        <p>Our Services</p>
        <span>All Imaging Service Under one roof</span>
        <div style={{ margin: "2rem 0px" }}>
          <div className="lpImagingCardServices">
            <img src={mriM} alt="mri" />
            <span>MRI Scan</span>
          </div>
          <div className="lpImagingCardServices">
            <img src={peetM} alt="mri" />
            <span>PET Scan</span>
          </div>
          <div className="lpImagingCardServices">
            <img src={ctM} alt="mri" />
            <span>CT Scan</span>
          </div>
          <div className="lpImagingCardServices">
            <img src={ultrasoundM} alt="mri" />
            <span>Ultrasound</span>
          </div>
          <div className="lpImagingCardServices">
            <img src={mammographyM} alt="mri" />
            <span>Mammography</span>
          </div>

          <div className="lpImagingCardServices">
            <img src={echo} alt="echo" />
            <span>ECHO</span>
          </div>
          <div className="lpImagingCardServices">
            <img src={xray} alt="echo" />
            <span>X-Ray</span>
          </div>
          <div className="lpImagingCardServices">
            <img src={tmt} alt="echo" />
            <span>TMT</span>
          </div>
        </div>
      </div>
      <div className="imagingTest">
        <div className="parentDiv  ">
          <div className="childDiv container">
            <div className="HeaderDiv">
              <div className="divHeading">
                <h2>Testimonials</h2>
                <p> </p>
              </div>
            </div>
            <Carousel
              swipeable={true}
              draggable={false}
              showDots={false}
              responsive={responsive}
              ssr={true} // means to render carousel on server-side.
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={2500}
              transitionDuration={200}
              deviceType={"tablet"}
            >
              {ImagingTestimonials.map((value) => {
                return (
                  <div
                    className="testimonial testimonialImaging"
                    key={value.id}
                  >
                    <div className="testimonial__card testimonial__cardHeight">
                      <div className="testimonial__cardHeader">
                        <img
                          src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/55febaec-ccb9-4709-8390-516c2bfc5687.webp"
                          alt="Profile logo"
                        ></img>
                        <div className="card__headerUserDetails">
                          <span>
                            {value.title ? (
                              <span>{value.author_name}</span>
                            ) : (
                              <span>nothing</span>
                            )}
                          </span>
                          <span>
                            {value.address ? (
                              <span>
                                {value.address}, {value.age}
                              </span>
                            ) : (
                              <span> </span>
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="testimonial__cardTitle">
                        <span>"{value.title}"</span>
                      </div>
                      <div className="testimonial__cardFooter">
                        <span>
                          <div>{value.description}</div>
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </Carousel>
          </div>
        </div>
      </div>
      <WhyChooseUs lpradio={true} Group={Group} />
      <Calltoaction />
      <div className="accordionNew">
        {home ? (
          <h2 className="h1style"> FAQs</h2>
        ) : (
          <h2 className="h1style"> Frequently Asked Questions</h2>
        )}

        {console.log("screen size ")}
        {ImagingFaq.map((value, index) => (
          <div key={value.id}>
            <FAQstructure value={value} />
          </div>
        ))}
      </div>
      <div className="ImagineDiscalimer">
        <span>
          Disclaimer: As per "Pre-Natal Diagnostic Techniques (Regulation and
          prevention of Misuse) Act, 1994", our labs strictly does not determine
          the sex of the fetus.
        </span>
      </div>
    </>
  );
}

export default {
  component: LpImageing,
};
